import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class BeneficiarioService {

    constructor(private http: HttpClient) { }
    sendForm(sessiondId: FormData): Observable<any> {
        return this.http.post(`${environment.urlApi}beneficiario/getPadronData`, sessiondId);
    }

    getPadronDataPorCuil(cuil: string | number, sessionId: any): Observable<any> {
        //return this.http.post(`${environment.urlApi}beneficiario/getPadronDataPorCuil`, cuil);
        return this.http.post(`${environment.urlApi}beneficiario/getPadronDataPorCuil`, {
            sessionId: sessionId,
            cuil: cuil
        });
    }

    
}
